module.exports = __webpack_public_path__ + "img/post4.470cb32f.png";